import Swal from 'sweetalert2';

/**
 * Confirm dialog for delete or other actions.
 * Returns a Promise that resolves to true if user confirms, false if cancel.
 */
export const confirmDialog = (options = {}) => {
  const {
    title = 'Are you sure?',
    text = 'This action cannot be undone.',
    confirmButtonText = 'Yes',
    cancelButtonText = 'Cancel',
    icon = 'warning',
    confirmButtonColor = '#38915c',
    cancelButtonColor = '#6b7280',
  } = options;

  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor,
    cancelButtonColor,
    reverseButtons: true,
  }).then((result) => !!result.isConfirmed);
};

const STORAGE_MSG =
  'Browser storage is full, usually because of pasted or uploaded videos/images. Use links (URLs) for videos and images instead of file upload, or remove some uploaded content.';

export const showStorageError = () => {
  return Swal.fire({
    icon: 'error',
    title: 'Storage limit reached',
    text: STORAGE_MSG,
    confirmButtonColor: '#38915c',
  });
};
